module.exports = __webpack_public_path__ + "static/media/trivia_button.77697ec0.png";